module.exports = __webpack_public_path__ + "static/media/mp.386b934f.svg";